module.exports = __webpack_public_path__ + "static/media/Accelerator.dbc7233f.jpg";